import { axios } from '../index'

const deleteShareFolderAccessProfile = (
  folderId: string,
  patientId: string,
  profileId: number
) => {
  return axios.delete(
    `/v1/folders/${folderId}/patients/${patientId}/profile/${profileId}`
  )
}

export default deleteShareFolderAccessProfile
